/** Re-export shared cart evaluation options. */
export type { CartEvaluationOptions } from '@shared/promotions/cartEvaluationOptions';
export { normalizePromoCode, resolveManualPromoCodes } from '@shared/promotions/cartEvaluationOptions';
